import React from "react";
import {
    Row,
    Col,
    Input,
    Button,
    Card,
    List as AntList,
    Modal,
    message
} from "antd";
import { Table } from "components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import {
    proceedCase,
    rejectCase,
    createBulkAdhocCase
} from "store/actions";
import CaseAdhocForm from "forms/case-adhoc-form";
import CaseService from "services/case-service";
import { OrderedMap, List } from "immutable";
import { CASE_CATEGORY_TYPES } from "constants/enums";
import { formatCurrency } from "utilities/currency";
import CompanyService from "services/company-service";
import StageService from "services/stage-service";
// import moment from "moment";

const EXISTING_CASES_LIST_COLS = new OrderedMap({
    caseId: {
        title: "Case ID",
        dataIndex:"id",
        key: "id",
        render: _ => `PGCP-${_}`,
        width: 40,
        align: "center"
    },
    // productId: {
    //     title: "Product",
    //     dataIndex:"product_name",
    //     key: "product_name",
    //     width: 200,
    //     align: "center"
    // },
    // dealer: {
    //     title: "Dealer",
    //     dataIndex: "company",
    //     key: "company",
    //     width: 200,
    //     align: "center"
    // },
    // sellers: {
    //     title: "Seller(s)",
    //     dataIndex: "sellers",
    //     key: "sellers",
    //     render: _ => _ && _.length ? _.join(", ") : "",
    //     width: 250,
    //     align: "center"
    // },
    // anchors: {
    //     title: "Anchor(s)",
    //     dataIndex: "anchors",
    //     key: "anchors",
    //     render: _ => _ && _.length ? _.join(", ") : "",
    //     width: 250,
    //     align: "center"
    // },
    // brands: {
    //     title: "Brand(s)",
    //     dataIndex: "brands",
    //     key:"brands",
    //     render: _ => _ && _.length ? _.join(", ") : "",
    //     width: 250,
    //     align: "center"
    // },
    fi: {
        title: "FI",
        key: "fi",
        dataIndex: "fi",
        width: 40,
        align: "center"
    },
    progcap_score: {
        title: "Progcap Score",
        dataIndex: "progcap_score",
        key: "progcap_score",
        render: _ => formatCurrency(_, true),
        width: 60,
        align: "center"
    },
    main_borrower_cibil: {
        title: "Main Borrower CIBIL",
        dataIndex: "main_borrower_cibil",
        key: "main_borrower_cibil",
        render: _ => formatCurrency(_, true),
        width: 60,
        align: "center"
    },
    requesting_user: {
        title: "Requesting User",
        dataIndex: "requesting_user",
        key: "requesting_user",
        render: _ => formatCurrency(_, true),
        width: 80,
        align: "center"
    },
    case_type: {
        title: "Case Type",
        key: "case_type",
        dataIndex: "case_type",
        render: _ => CASE_CATEGORY_TYPES.findKey(__ => __ == _),
        width: 60,
        align: "center"
    },
    sanctioned_limit: {
        title: "Sanctioned Limit",
        dataIndex: "sanctioned_limit",
        key: "sanctioned_limit",
        render: _ => formatCurrency(_, true),
        width: 60,
        align: "center"
    },
    outstanding_limit: {
        title: "Outstanding Limit",
        dataIndex: "outstanding_limit",
        key: "outstanding_limit",
        render: _ => formatCurrency(_, true),
        width: 60,
        align: "center"
    },
    limit_utilization_perc: {
        title: "Limit Utilization (%)",
        dataIndex: "limit_utilization_perc",
        key: "limit_utilization_perc",
        width: 70,
        align: "center"
    }
});

const PROPOSAL_FIELDS = new OrderedMap({
    lending_partner: {
        title: "Proposed Lender",
        key: "lending_partner",
        value: "Starfin"
    },
    proposed_limit: {
        title: "Proposed Limit",
        key: "proposed_limit",
        value: "10,00,000.00"
    },
    facility_type: {
        title: "Facility Type",
        key: "facility_type",
        value: "Enhancement/Ad-hoc"
    },
    tenor: {
        title: "Tenor",
        key: "tenor",
        value: "30 days"
    }
});

class AdhocEnhancementTab extends React.Component {
    state = {
        previousSanctionedCases: new List([]),
        remarks: null,
        stages: new List([]),
        stage: null,
        user: null,
        userId: null,
        showRequestModal: false,
        lending_partners: null
    };
    componentDidMount() {
        CaseService.getPreviousSanctionedList(this.props.caseId).then(({ data: { results } }) => {
            this.setState({
                previousSanctionedCases: new List(results)
            });
        });
        CompanyService.getLendingPartners().then(({data}) => {
            this.setState({
                lending_partners: data
            });
        }).catch(() => {});
    }

    getValueOfKey = (key) => {
        if(key === "lending_partner") {
            return this.props.caseDetails && this.props.caseDetails.getIn(["bank", "name"]);
        }
        if(key === "proposed_limit") {
            const limit = this.props.caseDetails && this.props.caseDetails.get("proposed_limit");
            return formatCurrency(limit);
        }
        if(key === "facility_type") {
            const type = this.props.caseDetails && this.props.caseDetails.get("case_type");
            return CASE_CATEGORY_TYPES.findKey(_ => _ == type);
        }
        if(key === "tenor") {
            return this.props.caseDetails && this.props.caseDetails.tenure;
        }
        return "";
    }


    onChangeRemarks = (e) => {
        this.setState({
            remarks: e.target.value
        });
    }

    approveCase = () => {
        this.props.proceedCase(
            this.props.caseTaskId,
            this.props.caseId,
            this.state.stage,
            this.state.userId,
            this.state.remarks,
            this.props.stageName,
            this.props.stageId
        );
    }

    toggleRequestModal = () => {
        this.setState({
            showRequestModal: !this.state.showRequestModal
        });
    }

    renderUserList = () => {
        let users = this.state.stages.find(_ => _.id === this.state.stage).user_list;
        this.setState({
            user: users,
            userId: users[0].id
        }, () => this.approveCase());
    };

    fetchStagesList = () => {
        StageService.getStages(
            this.props.stageId,
            "proceed",
            this.props.caseId
        ).then(({ data }) => {
            this.setState({
                stages: new List(data),
                loading: false
            }, () => {
                this.setState({
                    stage: this.state.stages.first().id
                }, () => {
                    this.renderUserList();
                });
            });
        }).catch(() => {
            this.setState({
                disableForm: false
            }, () => {
                message.error("Internet Connectivity Issue");
            });
        });
    }

    reject = () => {
        this.props.rejectCase(
            this.props.caseId,
            "Others",
            this.state.remarks,
            this.props.stageName,
            this.props.stageId
        );
    }

    onSubmitAdhocRequest = (values) => {
        this.props.createBulkAdhocCase([{
            ...values,
            case_id: this.props.caseId,
            case_type: 5,
            create: true
        }]);
        this.toggleRequestModal();
    }

    render() {
        console.log("inside render 23", this.props.recreditViewOnlyPermission);
        return (
            <React.Fragment>
                <Modal
                    title={"Create Request Form"}
                    visible={this.state.showRequestModal}
                    footer={null}
                    closable={true}
                    width={"380px"}
                    destroyOnClose={null}
                    onCancel={this.toggleRequestModal}
                >
                    <div className={"p-10"}>
                        <CaseAdhocForm
                            onFormSubmit={this.onSubmitAdhocRequest}
                            lending_partners={this.state.lending_partners}
                        />
                    </div>
                </Modal>
                <Row className={"p-5"} style={{
                    margin: "40px",
                    background: "#ffffff"
                }}>
                    {/* <Col offset={2} span={20} className={"p-10 d-flex justify-content-flex-end"}>
                        <Button type={"primary"} onClick={this.toggleRequestModal}>
                            {"Create An Adhoc Request"}
                        </Button>
                    </Col> */}
                    <Col offset={2} span={20} className={"p-10"}>
                        <Card
                            style={{
                                boxShadow: "none"
                            }}
                            title={"Existing Case(s)"}
                            className={"padless-card no-shadow-card"}
                        >
                            <Table
                                showTopSection={false}
                                pagination={false}
                                noRowSelection={true}
                                columns={EXISTING_CASES_LIST_COLS}
                                data={this.state.previousSanctionedCases}
                            />
                        </Card>
                    </Col>
                    <Col offset={2} span={20} className={"p-10 mt-10"}>
                        <div style={{
                            textAlign: "center",
                            lineHeight: "20px",
                            fontSize: "14px",
                            fontWeight: "600"
                        }}>
                            <span>Proposal</span>
                        </div>
                    </Col>
                    <Col offset={2} span={20} className={"mt-05 d-flex justify-content-center"}>
                        <AntList
                            style={{
                                background: "#efefef75",
                                width: "400px"
                            }}
                            className={"p-10"}
                            itemLayout={"horizontal"}
                            dataSource={PROPOSAL_FIELDS.toList().toArray()}
                            renderItem={_ => (
                                <AntList.Item>
                                    <AntList.Item.Meta
                                        title={(
                                            <div key={_.key} className={"d-flex"}>
                                                <span style={{ fontWeight: "bold" }} className={"fb-50"}>
                                                    {_.title}
                                                </span>
                                                <span className={"fb-50"}>
                                                    {this.getValueOfKey(_.key)}
                                                </span>
                                            </div>
                                        )}
                                    />
                                </AntList.Item>
                            )}
                        />
                    </Col>
                    <Col offset={2} span={20} className={"mt-20 d-flex flex-column"} style={{
                        marginBottom: "20px"
                    }}>
                        <span style={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "24px",
                            marginBottom: "10px"
                        }}>Rationale for Request/Approval<span style={{ color: "red" }}>* (Mandatory)</span></span>
                        <Input.TextArea placeholder={"Enter Your Comments Here"} rows={4} onChange={this.onChangeRemarks} />
                        <div className="mt-5 d-flex justify-content-flex-end">
                            <Button onClick={this.reject} disabled={!(!this.props.recreditViewOnlyPermission && !this.state.remarks)}>Reject</Button>
                            <Button type={"primary"} disabled={!this.state.remarks} className={"ml-10"} onClick={this.fetchStagesList}>{"Approve"}</Button>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

AdhocEnhancementTab.propTypes = {
    companyId: PropTypes.number,
    caseId: PropTypes.number,
    caseDetails: PropTypes.object,
    proceedCase: PropTypes.func,
    rejectCase: PropTypes.func,
    caseTaskId: PropTypes.number,
    stageId: PropTypes.number,
    stageName: PropTypes.string,
    createBulkAdhocCase: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

const mapStateToProps = (state, props) => ({
    caseDetails: state.caseDetails.getIn([props.caseId, "data"])
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        proceedCase,
        rejectCase,
        createBulkAdhocCase
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdhocEnhancementTab);